import { useQuery } from 'react-query';
import { getTravelArrangements } from 'RestAPIs/travel-arrangements';

const useGetTravelArrangements = (employeeId: number) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['travelArrangements', 'list', employeeId],
    async () => {
      const { data } = await getTravelArrangements(employeeId);
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetTravelArrangements;
